import { PageContentWrapper } from '@lmc/ui-kit'
import useFeatureFlag from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import RotaPaywall from '../components/RotaPaywall/RotaPaywall'

export const RotaPaywallScreen = () => {
  const { hasRota } = useHomeType()

  const flags = useFeatureFlag({
    flagNames: ['rostering_paywall_screen']
  })?.data

  const flagRosteringPaywallScreenEnabled =
    flags?.rostering_paywall_screen?.enabled

  if (hasRota || !flagRosteringPaywallScreenEnabled) {
    return null
  }

  return (
    <PageContentWrapper
      $gap={12}
      $paddingTop={24}
      $paddingX={48}
      $paddingBottom={24}
    >
      <RotaPaywall />
    </PageContentWrapper>
  )
}
